// src/main.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme, MantineColorScheme } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

// Register service worker with auto update
registerSW({
	onRegistered(registration: ServiceWorkerRegistration | undefined) {
		console.log('SW Registered:', registration);
	},
	onRegisterError(error: Error) {
		console.log('SW registration error', error);
	},
});

function Root() {
	const [colorScheme] = useLocalStorage<MantineColorScheme>({
		key: 'mantine-color-scheme',
		defaultValue: 'light',
	});

	const theme = createTheme({
		primaryColor: 'blue',
		fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
		headings: {
			fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
			fontWeight: '700',
		},
		defaultRadius: 'md',
	});

	return (
		<MantineProvider theme={theme} defaultColorScheme={colorScheme}>
			<Notifications />
			<ErrorBoundary
				fallbackTitle='Application Error'
				fallbackMessage='The app encountered an error. Your data is safe.'
				showReload
			>
				<App />
			</ErrorBoundary>
		</MantineProvider>
	);
}

const rootElement = document.getElementById('root');
if (rootElement) {
	const root = createRoot(rootElement);
	root.render(
		<React.StrictMode>
			<Root />
		</React.StrictMode>
	);
}
